import React from "react";
import PropTypes from "prop-types";

import { Typography } from "@mui/material";

const HelperText = ({ name, value }) => {

  const helperText = {
    description: `${value?.length} characters (recommended: 100-150 characters)`,
  };

  if (!helperText[name]) return null;

  return (
    <Typography variant="caption" color="text.secondary">
      {helperText[name]}
    </Typography>
  );
};

HelperText.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string,
};

export default HelperText;
